/**
 * Parse JWT token to get user information
 * @returns {Object|null} The decoded token payload or null if invalid
 */
export const parseJwtToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  
  try {
    // Split the token and get the payload part (second part)
    const base64Url = token.split('.')[1];
    // Replace characters for base64 URL encoding
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // Decode the base64 string
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error parsing JWT token:', e);
    return null;
  }
};

/**
 * Check if the current user is staff or superuser
 * @returns {boolean} True if the user is staff or superuser
 */
export const isStaffOrSuperuser = () => {
  const payload = parseJwtToken();
  return payload ? (payload.is_staff || payload.is_superuser) : false;
};

/**
 * Get the CSRF token from cookies
 * @returns {string} The CSRF token or empty string if not found
 */
export const getCsrfToken = () => {
  const name = 'csrftoken=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  
  for (let cookie of cookieArray) {
    cookie = cookie.trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  
  return '';
};
